import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import AddBatch from "../../components/buttons/AddBatch";
import { getBatches } from "../../API/Batches";

const dayNames = ["S", "M", "T", "W", "Th", "F", "Sa"];

// Define the type for batch data
type Batch = {
  batch_id: string;
  timeslot: string;
  days: number[];
};

function BatchSessions() {
  const [rows, setRows] = React.useState<Batch[]>([]); // ✅ Fix: Explicit type

  React.useEffect(() => {
    getBatches()
      .then((data) => {
        
        if (Array.isArray(data)) {
          setRows(data as Batch[]); // ✅ Ensure TypeScript recognizes the type
        } else {
          console.error("Unexpected data format:", data);
        }
      })
      .catch((error) => {
        console.error("Error fetching batches:", error);
      });
  }, []);

  return (
    <TableContainer component={Paper} className="p-3" sx={{ width: "100%" }}>
      <div className="d-flex justify-content-between m-2">
        <h2 className="m-2 header-downTables-dashboard">Active Batches</h2>
        {/* <AddBatch /> */}
      </div>
      <Table aria-label="batch table" sx={{ minWidth: 200 }}>
        <TableHead>
          <TableRow className="table-head-dashboard">
            <TableCell align="left"><b>Batch ID</b></TableCell>
            <TableCell align="left"><b>Time Slot</b></TableCell>
            <TableCell align="left"><b>Days</b></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((batch) => (
            <TableRow hover key={batch.batch_id}>
              <TableCell>{batch.batch_id}</TableCell>
              <TableCell>{batch.timeslot}</TableCell>
              <TableCell>
                {batch.days.map((day) => dayNames[day]).join(", ")}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default BatchSessions;
